import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AppVersion } from '@zerops/models/app-version';
import { BuildProcessStates } from '../../build-state-steps.model';
import { getPipelineState } from '../../build-state-steps.utils';

@Component({
  selector: 'zui-init-prepare-step',
  templateUrl: './init-prepare-step.component.html',
  styleUrls: [ './init-prepare-step.component.scss' ],
 changeDetection: ChangeDetectionStrategy.OnPush
})
export class InitPrepareStepComponent {
  buildProcessStates = BuildProcessStates;

  @Input()
  set appVersion(v: AppVersion) {
    this._appVersion = v;
    this._state = getPipelineState(this._appVersion)?.INIT_PREPARE_CONTAINER;
  }
  get appVersion(): AppVersion {
    return this._appVersion;
  }

  @Input()
  hideText = false;

  _state: BuildProcessStates;
  private _appVersion: AppVersion;
}
